import gql from 'graphql-tag';

export const acceptChallengeMutation = gql`
	mutation AcceptChallenge($input: ChallengeInput) {
		acceptChallenge(input: $input) {
			id
		}
	}
`;
